import styled from 'styled-components';
import { ResponsiveImage } from '../../components/ResponsiveImage';
import { spacing } from '../../../styles/newThemeVariables.styles';
import { breakpointUp } from '../../../styles/mediaUtils';
import { typeScale } from '../../../styles/newTypography';

export const Authors = styled.div`
  grid-column: 1 / -1;
  display: flex;
  align-items: center;
  column-gap: ${spacing.space16};
  margin-bottom: ${spacing.space16};
  word-break: normal;
`;

export const Details = styled.div`
  display: flex;
  align-items: start;
  flex-direction: column;
`;

export const Avatar = styled(ResponsiveImage)`
  border-radius: 6.25rem;
  max-width: ${spacing.space40};
  max-height: ${spacing.space40};
  overflow: hidden;
`;

export const AvatarGroup = styled.div`
  display: flex;
  align-items: center;
  word-break: normal;
  flex-shrink: 0;

  ${Avatar} {
    margin-left: -${spacing.space16};
  }

  ${Avatar}:first-of-type {
    margin-left: 0;
  }
`;

export const Name = styled.div`
  ${typeScale.desktop.body.xs};
  color: ${({ theme }) => theme.textPrimary};
  margin-bottom: 0;

  @media ${breakpointUp.tablet} {
    ${typeScale.desktop.body.xs};
  }
`;

export const Bio = styled.div`
  ${typeScale.desktop.body.xs};
  color: ${({ theme }) => theme.text400};
  margin-bottom: 0;

  @media ${breakpointUp.tablet} {
    ${typeScale.desktop.body.xs};
  }
`;
